import { graces, ISensorAnalog } from './types'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { ValueDisplayIcon } from '../../components/ValueDisplay'
import { useGetMeasurmentColor } from '../../../hooks/useGetMeasurmentColor'
import { WiBarometer, WiDaySunny, WiHumidity, WiStrongWind, WiThermometer } from 'react-icons/wi'
import { TimeSeriesLineChart } from '../../../features/Charts/LineCharts/TimeSeriesLineChart'
import { useMemo } from 'react'
import { themedUseStyletron } from '../../../theme/customTheme'

export function OverviewPanel(props: ISensorAnalog) {
    const [css, theme] = themedUseStyletron();
    const [color] = useGetMeasurmentColor(props.dimension);
    const isNormalPercentSensor = props.schema === 'AutomationApps.Devices.Sensors.SensorAnalog' && props.dimension === '%';
    const myColor = isNormalPercentSensor ? theme.appColors.measurments.default : color;

    const lines = useMemo(() =>
        [{
            label: props.description,
            showMinMax: true,
            lineColor: myColor,
            objectId: props.id,
            resourceGroupId: props.resourceGroupId,
            propertyName: 'value',
            currentValue: props.value,
            fill: true,
            grace: graces[props.dimension]
        }]
        , [props.description, props.id, props.resourceGroupId, props.dimension]);

    return (
        <OverviewPanelWrapper {...props} icon={icons[props.dimension]} >
            <ValueDisplayIcon {...props} ></ValueDisplayIcon>
            <div className={css({ height: '220px', width: '100%' })}>
                <TimeSeriesLineChart
                    showLegend={false}
                    timespan={7 * 24 * 60}
                    enableZoom={false}
                    lines={lines}
                    summarizeBy={'1h'}
                    showAverage={false}></TimeSeriesLineChart>
            </div>
        </OverviewPanelWrapper>
    );
}

const icons = {
    '°C': <WiThermometer size='100%' ></WiThermometer>,
    '°F': <WiThermometer size='100%' ></WiThermometer>,
    '°K': <WiThermometer size='100%' ></WiThermometer>,
    '%rF': <WiHumidity size='100%' ></WiHumidity>,
    '%': <WiHumidity size='100%' ></WiHumidity>,
    'Pa': <WiBarometer size='100%' ></WiBarometer>,
    'pa': <WiBarometer size='100%' ></WiBarometer>,
    'bar': <WiBarometer size='100%' ></WiBarometer>,
    'm³/h': <WiStrongWind size='100%'></WiStrongWind>,
    'km/h': <WiStrongWind size='100%'></WiStrongWind>,
    'm/s': <WiStrongWind size='100%'></WiStrongWind>,
    'lx': <WiDaySunny size='100%'></WiDaySunny>,
    'lux': <WiDaySunny size='100%'></WiDaySunny>,
    'default': null,
} as IDictionary

interface IDictionary {
    [index: string]: any;
}